import { render, staticRenderFns } from "./ProjectLookbackPure.vue?vue&type=template&id=5906f1d0&scoped=true&"
import script from "./ProjectLookbackPure.vue?vue&type=script&lang=ts&"
export * from "./ProjectLookbackPure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLookbackPure.vue?vue&type=style&index=0&id=5906f1d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906f1d0",
  null
  
)

export default component.exports